// Import model
import { DataviewSubmissionResponse } from '../models/DataviewSubmissionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterSubmissionRequest } from '../models/FilterSubmissionRequest';
import { Submission } from '../models/Submission';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterSubmissionRequestSerializer } from './FilterSubmissionRequestSerializer';
import { SubmissionSerializer } from './SubmissionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewSubmissionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewSubmissionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewSubmissionResponse instance
   */
  static deserialize(json: string): DataviewSubmissionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewSubmissionResponse instance
   */
  static fromObject(obj: any): DataviewSubmissionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewSubmissionResponse');
    }


    const instance: DataviewSubmissionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        SubmissionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterSubmissionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewSubmissionResponse instances
   */
  static deserializeArray(json: string): DataviewSubmissionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewSubmissionResponse instance to a JSON string
   */
  static serialize(instance: DataviewSubmissionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewSubmissionResponse instance to a plain object
   */
  static toObject(instance: DataviewSubmissionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        SubmissionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterSubmissionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewSubmissionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewSubmissionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
